import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { required, InputField, ReactSelect, ToggleField } from "modules/4_final_form/web";
import { FormGroup, Label, Col, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { Field } from "react-final-form";
import classnames from "classnames";

// actions
import { getEmployees } from "modules/employees/actions";
import { getProductionStrumisContracts } from "modules/production/strumis/contracts/actions";
import { getUserManagements } from "modules/user_managements/actions";
import { getProjectStatuses } from "modules/project/statuses/actions";
import _ from "lodash";
import { getAddressBookCompanies } from "modules/address_book/companies/actions";
import AddressBookCompanyAddButton from "modules/address_book/companies/web/add_button";

const mapStateToProps = (state) => ({
  users: state.users,
  employees: state.employees,
  production_strumis_contracts: state.production_strumis_contracts,
  project_statuses: state.project_statuses,
  address_book_companies: state.address_book_companies,
});

class DetailsTab extends React.Component {
  constructor(props) {
    super(props);

    this.props.getUserManagements(true, true);
    this.props.getEmployees(false, false, true);
    this.props.getProductionStrumisContracts(true);
    this.props.getProjectStatuses(true);
    this.props.getAddressBookCompanies(true);
  }

  render() {
    const { employees, production_strumis_contracts, users, project_statuses, values, address_book_companies } = this.props;

    const display_project_statuses = _.filter(project_statuses, { role: 1 });
    const be_project_statuses = _.filter(project_statuses, { role: 2 });
    const hlr_project_statuses = _.filter(project_statuses, { role: 3 });
    const se_project_statuses = _.filter(project_statuses, { role: 3 });

    return (
      <Fragment>
        <FormGroup row>
          <Label md={2}>Number</Label>
          <Col md={4}>
            <Field component={InputField} name="number" type="number" parse={(value) => value} validate={required} />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label md={2}>Name</Label>
          <Col md={4}>
            <Field component={InputField} name="name" type="string" parse={(value) => value} validate={required} />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label md={2}>Client Company

            <AddressBookCompanyAddButton />
          </Label>
          <Col md={4}>
            <Field
              component={ReactSelect}
              options={_.map(address_book_companies, (e) => {
                return { label: e.name, value: e.id };
              })}
              name="company_id"
              placeholder="Select Project Manager..."
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label md={2}>Project manager</Label>
          <Col md={4}>
            <Field
              component={ReactSelect}
              options={_.map(users, (e) => {
                return { label: e.name, value: e.id };
              })}
              name="project_manager_id"
              placeholder="Select Project Manager..."
            />
          </Col>
          <Label md={2}>Site manager</Label>
          <Col md={4}>
            <Field
              component={ReactSelect}
              options={_.map(users, (e) => {
                return { label: e.name, value: e.id };
              })}
              name="site_manager_id"
              placeholder="Select Site Manager..."
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label md={2}>Detailer</Label>
          <Col md={4}>
            <Field
              component={ReactSelect}
              options={_.map(users, (e) => {
                return { label: e.name, value: e.id };
              })}
              name="detailer_id"
              placeholder="Select Detailer..."
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label md={2}>Head Estimator</Label>
          <Col md={4}>
            <Field
              component={ReactSelect}
              options={_.map(users, (e) => {
                return { label: e.name, value: e.id };
              })}
              name="head_estimator_id"
              placeholder="Select Head Estimator..."
              isClearable
              parse={(value) => value}
            />
          </Col>
        </FormGroup>
        <FormGroup row></FormGroup>
        <FormGroup row>
          <Label md={2}>Strumis Contract</Label>
          <Col md={10}>
            <Field
              component={ReactSelect}
              options={_.map(production_strumis_contracts, (sc) => {
                return { label: sc.display_name, value: sc.id, strumis_contract_id: sc.id };
              })}
              name="strumis_contracts_attributes"
              placeholder="Select Strumis Contract..."
              isClearable
              parse={(value) => value}
              multi
              sendDestroy
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label md={2}>Site Document Release Users Notifications</Label>
          <Col md={10}>
            <Field
              component={ReactSelect}
              options={_.map(users, (u) => {
                return { label: u.name, value: u.id, user_id: u.id };
              })}
              multi
              name="sdr_notify_users_attributes"
              sendDestroy
              placeholder="Select users to notify..."
            />
          </Col>
        </FormGroup>

        <hr />
        <h5>Status</h5>
        <FormGroup row>
          <Label md={2}>Project Status</Label>
          <Col md={4}>
            <Field
              component={ReactSelect}
              options={_.map(display_project_statuses, (e) => {
                return { label: e.name, value: e.id };
              })}
              name="status_id"
              placeholder="Select Project Status..."
              validate={required}
            />
          </Col>
        </FormGroup>

        {values?.status_id == 1 && (
          <Fragment>
            <FormGroup row>
              <Label md={2}>Business Evaluation Status</Label>
              <Col md={4}>
                <Field
                  component={ReactSelect}
                  options={_.map(be_project_statuses, (e) => {
                    return { label: e.name, value: e.id };
                  })}
                  name="be_status_id"
                  isClearable
                  parse={(value) => value}
                  placeholder="Select Business Evaluation Outcome..."
                />
              </Col>
            </FormGroup>
            {values?.be_status_id && (
              <FormGroup row>
                <Label md={2}>High Level Review Outcome</Label>
                <Col md={4}>
                  <Field
                    component={ReactSelect}
                    options={_.map(hlr_project_statuses, (e) => {
                      return { label: e.name, value: e.id };
                    })}
                    name="hlr_status_id"
                    isClearable
                    parse={(value) => value}
                    placeholder="Select HLR Outcome..."
                  />
                </Col>
              </FormGroup>
            )}
            {values?.hlr_status_id && (
              <FormGroup row>
                <Label md={2}>Submit Estimation Status</Label>
                <Col md={4}>
                  <Field
                    component={ReactSelect}
                    options={_.map(se_project_statuses, (e) => {
                      return { label: e.name, value: e.id };
                    })}
                    name="se_status_id"
                    isClearable
                    parse={(value) => value}
                    placeholder="Select Estimation Outcome..."
                  />
                </Col>
              </FormGroup>
            )}
          </Fragment>
        )}

        <hr />
        <FormGroup row>
          <Label md={2}>Archived</Label>
          <Col md={4}>
            <Field component={ToggleField} name="archived" />
          </Col>
        </FormGroup>
      </Fragment>
    );
  }
}

export default connect(mapStateToProps, { getEmployees, getProductionStrumisContracts, getUserManagements, getProjectStatuses, getAddressBookCompanies })(DetailsTab);
